import React from 'react'

const Banner = (props) => (
    <section id="banner" className="major imageContainer">
        <div className="inner">
            <header className="major">
                <h1>Bem-vindo à AH Business</h1>
            </header>
            <div className="content">
                <ul className="actions">
                    <li><a href="#one" className="button2 next2 scrolly">Ver mais</a></li>
                </ul>
            </div>
        </div>
    </section>
)

export default Banner



// WEBPACK FOOTER //
// ./src/components/Banner.js